/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { ApiResponse } from 'shared/interfaces/project';

export const getProjects = (): Promise<ApiResponse> => {
	return apiClient.get('/projects', {
		params: {
			pageSize: 100,
			sort: 'name',
		},
	});
};

export const useProjects = () => {
	const { data, isFetching, isFetched } = useQuery({
		queryKey: ['projects'],
		queryFn: () => getProjects(),
	});

	const updateList = (productions: any) =>
		productions && Array.isArray(productions)
			? productions.reduce(
					(acc: any, currentItem: any) => {
						const modifiedItem = {
							...currentItem,
						};
						acc.push(modifiedItem);

						return acc;
					},
					[]
				)
			: [];

	return {
		data: data ? updateList(data?.rows) : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
